import React, { Component, Fragment } from 'react';
import formToJson from '../../../utils/formToJson';
import { FIELD_NAME_MAP } from '../../../constants';
import { FormDialog } from '../../molecules';

/**
 * Description
 *
 * @typedef {*} Props
 * @prop {Function} onSuccess
 * @prop {Function} render
 * @prop {Function} submitHandler
 * @prop {String} backLabel
 * @prop {String} backHref
 * @prop {String} serverErrorContent
 * @prop {String} serverErrorMessage
 *
 * @augments {Component<Props>}
 */
export default class Form extends Component {

	state = {
		errors: [],
		isServerError: false,
		isSubmitting: false,
	};

	handleDialogClose = () => this.setState({ isServerError: false });

	handleElementChange ({ currentTarget }) {
		currentTarget.setCustomValidity('');
		currentTarget.removeEventListener('input', this.handleElementChange);
	}

	handleSubmit = async (event) => {
		event.preventDefault();

		this.setState({ isSubmitting: true });

		// Recipients receive a JSON representation of the form data.
		const data = formToJson(event.currentTarget);

		try {
			const response = await this.props.submitHandler(data);
			const { success, json } = response;
			if (success) {
				this.props.onSuccess(json);
			} else {
				this.setValidation(json);
			}
		} catch (error) {
			console.log(error); /* eslint-disable-line no-console */
			this.setState({ isServerError: true });
		}
		this.setState({ isSubmitting: false });
	};

	setValidation = (serverErrors) => {
		const serverErrorArray = Object.entries(serverErrors);

		const errors = serverErrorArray.map(([name, errors]) => {
			// NOTE: This is a temporary fix, as the API returns a mismatched fieldname with errors.
			const correctedName = name.replace(/message|error/, 'Error');

			const fieldName = this.props[FIELD_NAME_MAP[correctedName]] || correctedName;

			const element = document.getElementsByName(correctedName)[0];
			const reasons = Array.isArray(errors) ? errors.join(', ') : errors;

			if (element) {
				// @ts-ignore
				element.setCustomValidity(`${fieldName}: ${reasons}.`);
				element.addEventListener('input', this.handleElementChange);
			}

			return {
				fieldName,
				reasons,
			};
		});

		this.setState({ errors });
	}

	render () {
		const { backHref, backLabel, serverErrorContent, serverErrorMessage, render = () => {} } = this.props;
		const { isServerError, ...state } = this.state;

		return (
			<Fragment>
				<FormDialog
					content={serverErrorContent}
					error
					heading={serverErrorMessage}
					href={backHref}
					linkLabel={backLabel}
					onClose={this.handleDialogClose}
					visible={isServerError}
				/>
				<form onSubmit={this.handleSubmit}>
					{render(state)}
				</form>
			</Fragment>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/Form/Form.js